import { useEffect } from "react";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");

export default function Seo({ title, description, canonical, image, type, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image || `${SITE_URL}/trending-banner.jpg`);
    setMeta("property", "og:type", type || "website");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image || `${SITE_URL}/trending-banner.jpg`);
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical, image, type]);

  const jsonStr = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!jsonStr) return;
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = jsonStr;
    document.head.appendChild(s);
    return () => s.remove();
  }, [jsonStr]);

  return null;
}
